export const BOT_TAGS = [
  "入门",
  "简单",
  "普通",
  "困难",
  "专家",
  "图图犬专用"
] as const

export type BotTag = (typeof BOT_TAGS)[number]

const BOT_TAG_SET = new Set<string>(BOT_TAGS)

function isBotTag(value: unknown): value is BotTag {
  return typeof value === "string" && BOT_TAG_SET.has(value)
}

export function normalizeBotTags(input: unknown): BotTag[] {
  const values = Array.isArray(input)
    ? input
    : typeof input === "string"
      ? [input]
      : []

  const normalized: BotTag[] = []
  const seen = new Set<BotTag>()

  for (const value of values) {
    if (!isBotTag(value)) {
      continue
    }

    if (seen.has(value)) {
      continue
    }

    seen.add(value)
    normalized.push(value)
  }

  return normalized
}

export function botMatchesTag(botTags: unknown, selectedTag: unknown): boolean {
  const normalizedSelectedTag = normalizeBotTags(selectedTag)
  if (normalizedSelectedTag.length === 0) {
    return false
  }

  return normalizeBotTags(botTags).some((tag) =>
    normalizedSelectedTag.includes(tag)
  )
}
